import Facets from 'components/search/Facets';
import FacetsV2 from 'components/search/FacetsV2';
import { FEATURE_SEARCH_FACETS_UPDATE } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';

type FacetsManagerProps = React.ComponentProps<typeof Facets> & {
  facetsV2: React.ComponentProps<typeof FacetsV2>['facets'];
};

export const FacetsManager = (props: FacetsManagerProps) => {
  const { isEnrolled: isSearchFacetUpdate } = useIsEnrolledInVariant(FEATURE_SEARCH_FACETS_UPDATE);

  if (isSearchFacetUpdate) {
    // Use navigationV2 facet experience
    return <FacetsV2 {...props} facets={props.facetsV2} />;
  }

  // Use existing facet experience
  return <Facets {...props} facets={props.facets} />;
};
